export function RolePath(role) {
  switch(role) {
    case "MASTER": {
      return "/admin"
    }
    case "IT" : {
      return "/support"
    }
    case "IT_LEADER" : {
      return "/support-leader"
    }
    case "SALE" : {
      return "/sale"
    }
    case "ACCOUNTING" : {
      return "/accounting"
    }
    default: {
      return "ACCESS_DENIED"
    }
  }
} 
export const LoginPageRole = {
  isAllowLogin: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER", "SALE", "ACCOUNTING"].includes(user_role);
  }
}

export const MangePageRole = {
  isShowSideBar: (user_role) => {
    return user_role == "MASTER";
  },
  isShowProductList: (user_role) => {
    return user_role == "MASTER";
  },
  isShowDCServerList: (user_role) => {
    return user_role == "MASTER"
  }
}

export const InvoicePageRole = {
  isShowSideBar: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER", "ACCOUNTING", "SALE"].includes(user_role);
  },
  isShowAgencyInvoice: (use_role) => {
    return use_role == "MASTER";
  },
  isShowInvoiceList: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER", "SALE"].includes(user_role);
  },
  isShowInvoiceStatic: (user_role) => {
    return ["MASTER", "SALE"].includes(user_role);
  },
  isShowTaduNote: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isShowHistory: (user_role) => {
    return ["MASTER"].includes(user_role);
  },
  isShowVATRequestInvoice: (user_role) => {
    return ["MASTER","ACCOUNTING"].includes(user_role);
  },
  isShowInvoiceDebtList: (user_role) => {
    return user_role == ["MASTER"]
  },
  isShowUserProductInfo: (user_role) => {
    return ["MASTER","IT", "IT_LEADER"].includes(user_role);
  },
  isModifyDomainProfile: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isServiceInfoChange: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isAllowSetupInvoiceItem: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isShowInvoiceMoney: (user_role) => {
    return ["MASTER", "ACCOUNTING", "SALE"].includes(user_role);
  },
  isCancelInvoice: (user_role) => {
    return user_role == "MASTER";
  },
  isVATRequestAction: (user_role) => {
    return ["MASTER", "ACCOUNTING"].includes(user_role);
  },
  isShowInvoicePagination: (user_role) => {
    return user_role == "MASTER";
  },
  isSetTrialInvoice: (user_role) => {
    return ["MASTER", "SALE"].includes(user_role);
  },
  // Dành cho sale
  isShowSaleCommission: (user_role) => { 
    return user_role === "SALE";
  }
}

export const TicketPageRole = {
  isShowSideBar: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isShowTicketList: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isTicketRating: (user_role) => {
    return ["MASTER", "IT_LEADER"].includes(user_role);
  },
  isShowTicketRateList: (user_role) => {
    return ["MASTER", "IT_LEADER"].includes(user_role);
  },
  isShowNewTicketNotify: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  }
}

export const CustomerPageRole = {
  isShowSideBar: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER", "SALE", "ACCOUNTING"].includes(user_role);
  },
  isCustomerList: (user_role) => {
    return ["MASTER", "SALE"].includes(user_role)
  },
  isProfileList: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER", "ACCOUNTING"].includes(user_role);
  },
  isActiveAccount: (use_role) => {
    return use_role == "MASTER";
  }
}

export const ReportPageRole = {
  isShowSideBar: (user_role) => {
    return user_role == "MASTER";
  },
  isShowAgencyAverageList: (user_role) => {
    return user_role == "MASTER";
  },
  isShowInvoiceWrongPriceList: (user_role) => {
    return user_role == "MASTER";
  }
}

export const ServicePageRole = {
  isShowSideBar: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isShowServiceRunning: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isShowServicePending: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isShowServiceExpired: (user_role) => {
    return user_role == "MASTER";
  },
  isShowServiceSuspend: (user_role) => {
    return user_role == "MASTER";
  },
  isShowServiceDeleted: (user_role) => {
    return user_role == "MASTER";
  },
  isDomainTracking: (user_role) => {
    return user_role == "MASTER";
  },
  isShowHistory: (user_role) => {
    return ["MASTER", "IT_LEADER"].includes(user_role);
  },
  isExpiredDateModify: (user_role) => {
    return ["MASTER", "IT_LEADER"].includes(user_role);
  },
  isTablePagination: (user_role) => {
    return "MASTER" == user_role;
  },
  isLoginHostingConfig: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isDNSConfig: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isVPSManage: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isAllowExpiredSuspend: (user_role) => {
    return ["MASTER", "IT", "IT_LEADER"].includes(user_role);
  },
  isAllowSuspendManual: (user_role) => {
    return ["MASTER", "IT_LEADER"].includes(user_role);
  },
  isAllowFinishTransfer: (user_role) => {
    return ["MASTER", "IT" ,"IT_LEADER"].includes(user_role);
  },
  isShowDomainProfile: (user_role) => {
    return ["MASTER", "IT" ,"IT_LEADER"].includes(user_role);
  }
}

export const BillingPageRole =  {
  isShowSideBar: (user_role) => {
    return user_role == "MASTER";
  },
  isShowBillingList: (user_role) => {
    return user_role == "MASTER";
  },
  isShowBillingInvoiceList: (user_role) => {
    return user_role == "MASTER";
  },
}

export const SettingPageRole =  {
  isShowSideBar: (user_role) => {
    return user_role === "MASTER";
  },
  isShowMobileVersionPage: (user_role) => {
    return user_role === "MASTER";
  },
  
}

